import { render } from "./registrationPracticeDetails.vue?vue&type=template&id=b74976c0&scoped=true"
import script from "./registrationPracticeDetails.vue?vue&type=script&lang=js"
export * from "./registrationPracticeDetails.vue?vue&type=script&lang=js"

import "./registrationPracticeDetails.vue?vue&type=style&index=0&id=b74976c0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74976c0"]])

export default __exports__